class SearchForm extends HTMLElement {
  /**
   * Initializes the SearchForm component.
   */
  constructor() {
    super();

    this.DEBOUNCE_INTERVAL = 300;
    this.HAS_INPUT_CLASS = "search--has-value";
  }

  /**
   * Lifecycle method called when the element is added to the DOM.
   */
  connectedCallback() {
    if (this.input) this.addListeners();
  }

  /**
   * Adds event listeners for input and reset button.
   */
  addListeners() {
    this.resetButton?.addEventListener("click", event => this.onFormReset(event));
    this.input.addEventListener(
      "input",
      debounce(event => this.onChange(event), this.DEBOUNCE_INTERVAL)
    );
  }

  /**
   * Handles input changes and toggles the active state.
   */
  onChange() {
    const hasValue = this.input.value.length > 0;
    const action = hasValue ? "add" : "remove";

    this.classList[action](this.HAS_INPUT_CLASS);
  }

  /**
   * Handles form reset, clears input and focuses it.
   * @param {Event} event - The click event.
   */
  onFormReset(event) {
    event.preventDefault();

    this.input.value = "";
    this.input.focus();
    this.onChange();
  }

  /**
   * Returns the search form element.
   */
  get form() {
    return this.querySelector("[data-search-form]");
  }

  /**
   * Returns the search input element.
   */
  get input() {
    return this.querySelector("[data-search-input]");
  }

  /**
   * Returns the reset button element.
   */
  get resetButton() {
    return this.querySelector("[data-search-reset]");
  }
}

customElements.define('search-form', SearchForm);
